// extracted by mini-css-extract-plugin
export default {"box":"styles_box__QgjeX","image":"styles_image__iB04v","info":"styles_info__+HqVv"};